<template>
	<v-menu
		@click.prevent=""
		v-model="datePickerOpen"
		:disabled="disabled"
		:close-on-content-click="false"
		full-width
		max-width="280"
	>
		<v-text-field
			:value="selectedDateFormated"
			:label="label"
			readonly
			slot="activator"
		></v-text-field>

		<v-date-picker
			first-day-of-week="1"
			locale="de-de"
			v-model="internalDate"
			@change="dateChanged()"
		></v-date-picker>
	</v-menu>
</template>

<script>
import moment from "moment";

export default {
	props: {
		selectedDate: "",
		label: "",
		disabled: false,
	},
	data() {
		return {
			datePickerOpen: false,
			internalDate: "",
		};
	},
	mounted: function () {
		this.setDate();
	},
	watch: {
		selectedDate() {
			this.setDate();
		},
	},
	computed: {
		selectedDateFormated() {
			moment.locale("de");
			return this.internalDate ? moment(this.internalDate).format("DD.MM.YYYY") : "";
		},
	},
	methods: {
		setDate() {
			this.internalDate = moment(this.selectedDate).format("YYYY-MM-DD");
		},
		dateChanged() {
			this.$emit("updateSelectedDate", this.internalDate);
			this.datePickerOpen = false;
		},
	},
};
</script>
